import React, {useEffect} from 'react';
import Breadcrumbs from "../../../../../../ui/Breadcrumbs";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import MyInOrdersTable from "../../components/MyInOrdersTable";

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Заказы",
    link: "/work/app/manage/orders"
  },
  {
    label: "Заказы организаций",
    link: "/work/app/manage/orders/orgorders"
  },
  {
    label: "Мои входящие заказы",
    link: "#"
  }
];

const MyInOrderList = () => {
  return (
    <div>
      <Breadcrumbs items={items} />
      <MyInOrdersTable/>
    </div>
  );
};

export default MyInOrderList;
